import script from "./EnergyCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./EnergyCounter.vue?vue&type=script&setup=true&lang=js"

import "./EnergyCounter.vue?vue&type=style&index=0&id=f643b49a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f643b49a"]])

export default __exports__